<template>
  <div class="document-preview">
    <pdf
      class="elevation-2 doc-thumb"
      v-show="doc.mime_type === 'application/pdf'"
      :src="documentSrc"
      :page="page"
      :style="pdfStyle"
    />
    <v-layout
      v-show="doc.mime_type !== 'application/pdf'"
      class="elevation-2 doc-thumb"
      justify-center
      align-center
    >
      <v-icon>
        {{ fileStateIcon(doc.mime_type) }}
      </v-icon>
    </v-layout>
    <v-chip class="document-state" :color="chipColor" text-color="white" small>
      <strong class="text-uppercase">{{ doc.document_state.state === 'DocGo' ?
                              doc.created_by.administrative_unit.abbreviation :
                              doc.created_by.administrative_unit.abbreviation + ' (' + doc.document_state.state + ')' }}</strong>
    </v-chip>

    <v-tooltip bottom max-width="500">
      <highlighter
        class="text-truncate"
        slot="activator"
        :searchWords="keywords"
        :textToHighlight="truncate(doc.document_type.name, { length: 24 })"
        autoEscape
        highlightClassName="highlight"
      />
      <span>{{ doc.document_type.name }}</span>
    </v-tooltip>
  </div>
</template>

<script>
import pdf from 'vue-pdf';
import { last, truncate } from 'lodash';
import Highlighter from 'vue-highlight-words';
import fileStateIcon from '@/mixins/file-state-icon';

export default {
  name: 'DocumentThumb',
  props: {
    doc: {
      type: Object,
    },
    searchDocumentString: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      fileStateIcon,
      last,
      page: 1,
    };
  },
  components: {
    Highlighter,
    pdf,
  },
  methods: {
    truncate,
  },
  computed: {
    documentSrc() {
      const lastVersion = last(this.doc.document_versions);
      const loadingTask = pdf.createLoadingTask(lastVersion.file);
      pdf.disableAutoFetch = true;
      return loadingTask;
    },
    chipColor() {
      switch (this.doc.document_state.enum) {
        case 'minute':
          return 'amber';
        default:
          return 'grey darken-2';
      }
    },
    pdfStyle() {
      return {
        border: this.isPending && `2px solid ${this.borderColor}`,
        width: '150px',
        height: '215px',
      };
    },
    borderColor() {
      switch (this.doc.document_state.enum) {
        case 'minute':
          return 'amber';
        default:
          return 'accent';
      }
    },
    isPending() {
      const document = this.doc;
      return document.has_pending_revision || document.has_pending_signature;
    },
    keywords() {
      return this.searchDocumentString.split(' ');
    },
  },
};
</script>

<style>
.document-preview {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.document-version {
  align-self: flex-end;
  margin-bottom: -12px;
  margin-right: -20px;
  z-index: 1;
}
.document-state {
  margin-top: -10px;
}
.highlight {
  background-color: rgba(255, 226, 0, 0.3);
}
.doc-thumb {
  overflow: hidden;
  width: 150px;
  height: 212px;
}
</style>



// WEBPACK FOOTER //
// src/components/document/grid/DocumentThumb.vue